import { extendObservable } from 'mobx';
import axios from '../../../libs/axios_csrf';


export default class Keep {
  constructor(rootStore) {
    this.rootStore = rootStore;
    this.fetchData();

    extendObservable(this, {
      dataStartups: [],
      dataStickiness: [],
      dataRates: [],
      loaded: false,
    });
  }

  fetchData() {
    axios.get('/startup_statistics/action_manager/keep', {})
      .then((response) => {
        this.dataStartups = response.data.active_startups;
        this.dataStickiness = response.data.startups_stickiness;
        this.dataRates = response.data.rates;
        this.loaded = true;
      })
      .catch((error) => {
        console.log('An error happened!', error);
      });
  }
}
